import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cookies from 'js-cookie';
import 'numeral/locales/de';
import { initReactI18next } from 'react-i18next';
import ResActions from 'src/adminPanel/resources/locales/de/actions.json'; // AdminPanel
import ResAdminRoutes from 'src/adminPanel/resources/locales/de/adminRoutes.json'; // AdminPanel
import ResArticleManagement from 'src/adminPanel/resources/locales/de/articleManagement.json'; // AdminPanel
import ResIT from 'src/adminPanel/resources/locales/de/it.json'; // AdminPanel
import ResOffice from 'src/adminPanel/resources/locales/de/office.json'; // AdminPanel
import ResOffsetting from 'src/adminPanel/resources/locales/de/offsetting.json'; // AdminPanel
import ResService from 'src/adminPanel/resources/locales/de/service.json'; // AdminPanel
import ResAdminPanelV2 from 'src/adminPanelV2/resources/locales/de/adminpanel.json'; // AdminPanel V2
import { IS_DEVELOPMENT, IS_LOCAL, IS_PRODUCTION } from 'src/config/env';
import I18NextBackend from 'src/core/I18NextBackend';
import { translatorModePostProcessor, TRANSLATOR_MODE_EVENT } from 'src/core/translatorMode';
import ResCoffeehouseTranslations from 'src/resources/locales/de/coffeehouse_translations.json';
import ResContact from 'src/resources/locales/de/contact.json';
import ResContentmanager from 'src/resources/locales/de/contentmanager.json';
import ResCountries from 'src/resources/locales/de/countries.json';
import ResForm from 'src/resources/locales/de/form.json';
import ResLanguages from 'src/resources/locales/de/languages.json';
import ResProducts from 'src/resources/locales/de/products.json';
import ResRepresentatives from 'src/resources/locales/de/representatives.json';
import ResRoutes from 'src/resources/locales/de/routes.json';
import ResStatic from 'src/resources/locales/de/static.json';
import ResTestimonials from 'src/resources/locales/de/testimonials.json';
import ResTranslations from 'src/resources/locales/de/translations.json';
import ResValidations from 'src/resources/locales/de/validations.json';
import ResWebseite from 'src/resources/locales/de/webseite.json';

/**
 * Format for translation strings of the form {{value, format}}.
 * Creates a new moment with the current language when the language changes.
 *
 * https://www.i18next.com/overview/api#format
 * https://momentjs.com/docs/#/i18n/changing-locale/
 */
// const format = (value: any, formatString?: string, lng?: string): string => {
//     // if (moment.isMoment(value)) return (value as moment.Moment).locale(lng || FALLBACK_LANGUAGE).format(formatString);
//     if (value instanceof Money) {
//         if (formatString) return value.format(formatString);
//         return value.toString();
//     } else return value;
// };

export const FALLBACK_LANGUAGE = 'en-at';
export const BASE_LANGUAGE = 'en';
export const BASE_REGION = 'at';
export const BASE_TEMPLATE_TYPE = 'PLAIN_TEXT';
const LOCALE_COOKIE = 'LOCALE';

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
    name: 'default',
    lookup(options) {
        return 'de-at';
    },
});

const isLamanteSite = (() => {
    const envSiteId = process.env.REACT_APP_SITE_ID?.toLowerCase();
    if (envSiteId === 'lamante') return true;

    if (typeof window !== 'undefined') {
        const host = window.location.hostname?.toLowerCase();
        if (host?.includes('lamante')) return true;
    }

    return false;
})();

const i18nChain = i18next.use(languageDetector).use(initReactI18next).use(translatorModePostProcessor);

if (isLamanteSite) {
    i18nChain.use(I18NextBackend);
}

i18nChain.init({
    load: 'currentOnly',
    lowerCaseLng: true,
    fallbackLng: [BASE_LANGUAGE, FALLBACK_LANGUAGE],
    detection: {
        order: ['cookie', 'navigator', 'default'],
        lookupCookie: LOCALE_COOKIE,
    },
    ns: [
        'translations',
        'routes',
        'contact',
        'countries',
        'languages',
        'contentmanager',
        'form',
        'validations',
        'testimonials',
        'representatives',
        'products',
        'static',
        'webseite',
    ],
    defaultNS: 'translations',
    // Uncomment for debugging
    debug: !IS_PRODUCTION && false,
    react: {
        wait: true, // Wait until loaded in every translated HOC
        bindI18n: `languageChanged ${TRANSLATOR_MODE_EVENT}`,
    },
    interpolation: {
        escapeValue: false, // Don't escape values; we have no user-submitted translations
    },
    saveMissing: true,
    backend: {
        loadPath: process.env.PUBLIC_URL + '/locales/{{lng}}/{{ns}}.json',
    },
    partialBundledLanguages: true,
});

i18next.addResourceBundle(BASE_LANGUAGE, 'actions', ResActions, true, false); // AdminPanel
i18next.addResourceBundle(BASE_LANGUAGE, 'adminpanel', ResAdminPanelV2, true, false); // AdminPanel V2
i18next.addResourceBundle(BASE_LANGUAGE, 'coffeehouse', ResCoffeehouseTranslations, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'adminroutes', ResAdminRoutes, true, false); // AdminPanel
i18next.addResourceBundle(BASE_LANGUAGE, 'articlemanagement', ResArticleManagement, true, false); // AdminPanel
i18next.addResourceBundle(BASE_LANGUAGE, 'contact', ResContact, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'contentmanager', ResContentmanager, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'countries', ResCountries, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'form', ResForm, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'it', ResIT, true, false); // AdminPanel
i18next.addResourceBundle(BASE_LANGUAGE, 'languages', ResLanguages, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'office', ResOffice, true, false); // AdminPanel
i18next.addResourceBundle(BASE_LANGUAGE, 'offsetting', ResOffsetting, true, false); // AdminPanel
i18next.addResourceBundle(BASE_LANGUAGE, 'products', ResProducts, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'representatives', ResRepresentatives, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'routes', ResRoutes, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'testimonials', ResTestimonials, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'translations', ResTranslations, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'validations', ResValidations, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'service', ResService, true, false); // AdminPanel
i18next.addResourceBundle(BASE_LANGUAGE, 'static', ResStatic, true, false);
i18next.addResourceBundle(BASE_LANGUAGE, 'webseite', ResWebseite, true, false);

// Fall back to the lowercased key so that camelCase usage in code and lowercase keys
// in JSON (and backend templates) resolve consistently, while mixed-case keys
// (e.g. AdminPanel V2 'detail.re_state_OPEN') still resolve as written.
// e.g. t('order_table.newCustomerInfoButton') → 'order_table.newcustomerinfobutton'
// The key as written comes last again: on a miss i18next shows the last key, so a text that is no key stays as written.
const withLowercaseFallback = (key: string): string[] =>
    key === key.toLowerCase() ? [key] : [key, key.toLowerCase(), key];
const _origT = i18next.t.bind(i18next);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
i18next.t = (key: any, ...args: any[]) => {
    if (typeof key === 'string') return _origT(withLowercaseFallback(key), ...args);
    if (Array.isArray(key)) return _origT(key.flatMap(withLowercaseFallback), ...args);
    return _origT(key, ...args);
};

i18next.on('languageChanged', (locale: string): void => {
    Cookies.set(LOCALE_COOKIE, locale, {
        secure: true,
        domain: IS_DEVELOPMENT || IS_LOCAL ? undefined : 'lamante.com',
        expires: 365,
        sameSite: 'strict',
    });
});

export default i18next;
